import React, { useState, useEffect, useRef } from 'react';
import GroupLayer from './GroupLayer';
import useProps from "../_util/useProps";
import Provider from "../_util/Provider";
import { useUpdateEffect } from 'ahooks';

export default function(props) {
    const {children, index, id, _key, name, legend, layerControl = true, show} = props;
    const { map, groupLayer } = useProps();

    const [layerLoad, setLayerLoad] = useState(false);

    const layer = useRef();

    useEffect(() => {
        layer.current = new GroupLayer({
            key: id || _key,
            name,
            legend,
            layerControl,
            index,
            map
        });

        if (groupLayer) {
            groupLayer.addLayer(layer.current)
        } else {
            map.addLayer(layer.current);
        }

        setLayerLoad(true);

        return () => {
            if (groupLayer) {
                groupLayer.removeLayer(layer.current)
            } else {
                map.removeLayer(layer.current);
            }
        }
    }, [])

    useUpdateEffect(() => {
        layer.current.setVisible(show);
    }, [show]);

    return (
        <>
            {layerLoad && (
                <Provider
                    value={{
                        map,
                        groupLayer: layer.current,
                    }}
                >
                    {children}
                </Provider>
            )}
        </>
    );
}
